import clsx from 'clsx';
import type { ReactNode } from 'react';

import styles from './Screen.module.scss';

interface ScreenProps {
  title?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** Каркас экрана: заголовок, безопасные отступы, скролл контента. */
export function Screen({ title, action, children, className }: ScreenProps) {
  return (
    <section className={clsx(styles.screen, className)}>
      {title ? (
        <header className={styles.header}>
          <h1 className={styles.title}>{title}</h1>
          {action}
        </header>
      ) : null}
      <div className={styles.content}>{children}</div>
    </section>
  );
}
